<template>
  <table-layout title="سطل زباله" :showSearch="false">
    <template #buttons>

      <router-link :to="{ name: 'Feature' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
          > بازگشت به صفحه ویژگی ها </b-button
        >
      </router-link>
    </template>
    <template #table>
      <tabel-items :items="features" :restoreState="true" />
      <div class="row pt-3">
        <div class="mt-3 color">
          <pagination :meta="paginationMeta" :on-change-page="changePage" />
        </div>
      </div>
    </template>
  </table-layout>
</template>

<script>
import { mapGetters } from "vuex";
import TableLayout from "../TableLayout.vue";
import Pagination from "../Pagination.vue";
import tabelItems from "./tableItems.vue"

export default {
  name: "TrashFeatures",
  components: { TableLayout, Pagination ,tabelItems },

  mounted() {
    this.$store.dispatch("Feature/trashFeatures");
  },
  computed: {
    ...mapGetters({
      features: "Feature/getTrash",
      paginationMeta: "Feature/getPaginationMeta",
    }),
  },
methods:{
    changePage(page) {
      console.log("page", page);
      this.$store.dispatch("Feature/trashFeatures",page);

    },
   
  }
};
</script>

<style scoped>
</style>